module.exports = __webpack_public_path__ + "static/img/news_31.2799a23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_31.png
// module id = FznO
// module chunks = 2